function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fill: "#545358",
  fillRule: "evenodd",
  d: "M4 3.21v17.58C4 21.46 4.585 22 5.306 22h14.779c.72 0 1.306-.541 1.306-1.21V3.21c0-.669-.585-1.21-1.306-1.21H5.306C4.586 2 4 2.541 4 3.21zM19.505 20.7H5.895c-.384 0-.695-.276-.695-.613V3.913c0-.338.311-.613.695-.613h13.61c.384 0 .695.275.695.613v16.174c0 .337-.311.613-.695.613zM17 7.96c-.001.41-.411.757-.916.757H8.916C8.41 8.717 8 8.385 8 7.974c0-.409.41-.757.916-.757h7.168c.506 0 .916.333.916.743zm-1.11 3.478c-.001.41-.36.758-.803.758H8.803c-.444 0-.803-.333-.803-.743s.36-.757.803-.757h6.284c.443 0 .803.333.803.742zm-.87 3.478c0 .41-.425.758-.948.758H8.95c-.524 0-.949-.332-.949-.743 0-.41.425-.757.949-.757h5.123c.523 0 .948.332.948.742z"
});

var SvgDoc = function SvgDoc(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgDoc, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/doc.6b164a81.svg";
export { ForwardRef as ReactComponent };